var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-view__cell active"},[_c('div',{staticClass:"grid-field-boolean"},[_c('div',{staticClass:"grid-field-boolean__checkbox",class:{
        active: _vm.value,
        'grid-field-boolean__checkbox--read-only': _vm.readOnly,
      },on:{"click":function($event){return _vm.toggle(_vm.value)}}},[_c('i',{staticClass:"iconoir-check grid-field-boolean__checkbox-icon"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }